/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError, AxiosResponse } from "axios";
import { Service } from "../network.service";
import {
  AreValidationsRequiredResponse,
  NationalIdValidationResponse,
} from "../../models/IKycValidations";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { LogType } from "@/types/dataDogLogType";
import {
  HandleKycFlowRequest,
  NationalIdValidationRequest,
} from "../../types/requests";
import { ErrorHandler } from "../../helpers/errorHandlerWithLogger.helper";

export const areValidationRequired = async (
  data: HandleKycFlowRequest
): Promise<AxiosResponse<AreValidationsRequiredResponse, any>> => {
  const services = new Service();
  let response: AxiosResponse<AreValidationsRequiredResponse, any>;

  try {
    const res = await services.areValidationRequired(data);
    response = res;
  } catch (newApiError) {
    ErrorHandler.handleNetworkErrorAndLog(newApiError as AxiosError<any, any>);
    DatadogLogger.Log(
      "Error calling refactor KYC API (kyc validations are required).",
      newApiError as Record<string, unknown>,
      LogType.ERROR
    );
    return {
      data: {
        wasSuccessful: false,
        requiredValidations: [],
      },
      status: 200,
      statusText: "OK",
      headers: {},
      config: {} as any,
    } as AxiosResponse<AreValidationsRequiredResponse, any>;
  }

  return response;
};

export const validateNationId = async (
  data: NationalIdValidationRequest
): Promise<AxiosResponse<NationalIdValidationResponse, any>> => {
  const services = new Service();
  let response: AxiosResponse<NationalIdValidationResponse, any>;

  try {
    const res = await services.nationalIdValidation(data);
    response = res;
  } catch (newApiError) {
    ErrorHandler.handleNetworkErrorAndLog(newApiError as AxiosError<any, any>);
    DatadogLogger.Log(
      "Error calling refactor KYC API (validateNationId).",
      newApiError as Record<string, unknown>,
      LogType.ERROR
    );
    return {
      data: {
        status: "GENERAL_ERROR",
        attempts: 0,
      },
      status: 200,
      statusText: "OK",
      headers: {},
      config: {} as any,
    } as AxiosResponse<NationalIdValidationResponse, any>;
  }

  return response;
};
